<template>
   
        <v-data-table :headers="usersHeaders" :items="usersList"
        :hide-default-footer="true" disable-sort
        class="elevation-1" 
        >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('users') }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
        </v-data-table>
    
</template>
<script>
import axios from "axios";
export default ({
    name:'SessionUser',
    props:['roomId'],
    data() {
        return{
            usersHeaders:[ 
                { text: this.$t("name"), value: "name" },
                { text: this.$t("mobile"), value: "mobile" },
                { text: this.$t("email"), value: "email" },
            ],
            usersList:[],
            totalRows:0,
            loading:false
        }
    },
    methods:{
        getUsers(){
            if (this.roomId) {
                this.loading=true;
                const payload = { _startRow:0,_endRow:10000};
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/rooms/"+this.roomId+"/users",
                    method: 'GET',
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload,

                }).then(response => {
                    console.log("data", response.data.data)
                    const data = response.data.response.data;
                    this.usersList = data;
                    this.totalRows = data.length;
                    this.loading = false;
                });
            }
        }
    },
    mounted() {
        this.getUsers()
    },
})
</script>
